<div class="app-questionnaire-wrap" [ngClass]="{'show':isShowQuestionnaire}">
  <div class="app-questionnaire-layout">
    <questionnaire-title [questionnaireTitle] = "questionnaireTitle" *ngIf="questionnaireTitle"></questionnaire-title>
    <questionnaire-head-photo [questionnaireHeadPhotoUrlArray] = "questionnaireHeadPhotoUrlArray" [questionnaireLevel] = "questionnaireLevel" *ngIf="questionnaireHeadPhotoUrlArray.length > 0"></questionnaire-head-photo>
    <questionnaire-grade [questionnaireScoreArray] = "questionnaireScoreArray" *ngIf="questionnaireScoreArray.length > 0" (outPutLevel)="getQuestionnaireLevel($event)" ></questionnaire-grade>
    <questionnaire-tag [questionnaireContext]="questionnaireContext" [questionnaireTagArray] = "questionnaireTagArray" *ngIf="questionnaireTagArray.length > 0" (outPutSelectedTag)="getSelectedTag($event)"></questionnaire-tag>
    <questionnaire-textarea [selectedTag] = "selectedTag" [placeholder]="placeholder" (outPutTextareaContext)="getQuestionnaireContext($event)"></questionnaire-textarea>
  </div>

  <component-button [theme]="buttonTheme" [isDisabled]="isDisabled" (onExit)="closeQuestionnaire()" (onCommit)="commitQuestionnaire()"></component-button>
  <div id="message-box"  [ngClass]="{open:isOpenMessage,fontSize14:true}">{{ tipMessage }}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/app-questionnaire.component.html